module.exports = __webpack_public_path__ + "static/media/united-states-of-america.c90b64e5.svg";